import type { AxiosError } from 'axios';

export function messageFromError(error: unknown): string {
  const response = (error as AxiosError<{ error?: { message?: string } }>).response;
  return response?.data?.error?.message ?? 'Something went wrong. Please try again.';
}
